import { useNavigate } from 'react-router-dom';

import { useNotificationContext } from '../../contexts/NotificationContext';
import { formatRelativeTime } from '../../utils/formatRelativeTime';

const ICONS: Record<string, string> = {
  TICKET_ASSIGNED: '🎫',
  NEW_MESSAGE: '💬',
  INTERNAL_NOTE: '🔒',
  STATUS_CHANGED: '🔄',
};

export default function NotificationsPage() {
  const { notifications, unreadCount, markRead, markAllRead } = useNotificationContext();
  const navigate = useNavigate();

  return (
    <div className="notifications-page">
      <div className="notifications-page-header">
        <div>
          <h1 className="notifications-page-title">Notifications</h1>
          {unreadCount > 0 && (
            <p className="notifications-page-subtitle">{unreadCount} unread</p>
          )}
        </div>
        {unreadCount > 0 && (
          <button type="button" className="notifications-mark-all" onClick={() => void markAllRead()}>
            Mark all as read
          </button>
        )}
      </div>

      {notifications.length === 0 ? (
        <div className="notifications-empty">No notifications yet</div>
      ) : (
        <div className="notifications-list">
          {notifications.map((n) => (
            <div
              key={n.id}
              className={`notification-row${n.read ? '' : ' notification-row--unread'}${
                n.ticketId ? ' notification-row--clickable' : ''
              }`}
              role={n.ticketId ? 'button' : undefined}
              tabIndex={n.ticketId ? 0 : undefined}
              onClick={() => {
                if (!n.read) {
                  void markRead(n.id);
                }
                if (n.ticketId) {
                  navigate(`/tickets/${n.ticketId}`);
                }
              }}
              onKeyDown={(e) => {
                if (!n.ticketId) return;
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  if (!n.read) {
                    void markRead(n.id);
                  }
                  navigate(`/tickets/${n.ticketId}`);
                }
              }}
            >
              <span className="notification-row-icon" aria-hidden>
                {ICONS[n.type] ?? '🔔'}
              </span>
              <div className="notification-row-content">
                <div className="notification-row-top">
                  <span className={`notification-row-title${n.read ? '' : ' notification-row-title--bold'}`}>
                    {n.title}
                  </span>
                  {!n.read && <span className="notification-row-dot" aria-hidden />}
                </div>
                <div className="notification-row-body">{n.body}</div>
                <div className="notification-row-meta">
                  {formatRelativeTime(n.createdAt)}
                  {n.ticket && (
                    <span className="notification-row-ticket">#{n.ticket.ticketNumber}</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
